import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14M5.466 5.115a.5.5 0 0 1 .354-.146h1.84a.5.5 0 0 1 0 1H6.32v.403h1.11a.5.5 0 1 1 0 1H6.32v.66h1.34a.5.5 0 0 1 0 1H5.82a.5.5 0 0 1-.5-.5V5.468a.5.5 0 0 1 .146-.354M1.883 4.99a.5.5 0 0 1 .561.201L3.57 6.88V5.469a.5.5 0 0 1 1 0V8.53a.5.5 0 0 1-.916.278L2.528 7.12v1.411a.5.5 0 0 1-1 0V5.47a.5.5 0 0 1 .355-.479m9.44 4.041a.66.66 0 0 0 .654-.554l.488-2.926a.5.5 0 1 0-.986-.164l-.27 1.615-.211-.615a.59.59 0 0 0-1.115 0l-.211.615-.27-1.615a.5.5 0 1 0-.986.164l.488 2.926a.664.664 0 0 0 1.282.106l.255-.74.254.74a.66.66 0 0 0 .628.448",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const tagNewCircle = { render };
export {
  tagNewCircle as default,
  render
};
//# sourceMappingURL=tag-new-circle.svg.js.map
